exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".emptyContainer-2c12075f{height:400px;display:flex;flex-direction:column;justify-content:center;align-items:center;color:#757575}.emptyContainer-2c12075f span{color:#fff;margin-bottom:20px}.emptyContainer-2c12075f a{max-width:210px;font-size:13px;line-height:16px}\n", ""]);

// Exports
exports.locals = {
	"emptyContainer": "emptyContainer-2c12075f"
};